module.exports = __webpack_public_path__ + "img/logistics_first.746581ff.png";